
import postcssStyledJsxUrlLoader_0 from './medium-1.svg';
import css from 'styled-jsx/css';

export default css`.resources-hero {
  position: relative;
  padding: 60px 60px 100px 60px;
  background-color: $light-gray-legacy;
}

.background {
  background-image: url("${postcssStyledJsxUrlLoader_0}");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  right: 50%;
  transform: translate(50%, -50%) scale(1.3);
  height: 100%;
  width: 100%;
  top: 50%;
  position: absolute;
  bottom: 0;
  z-index: -3;
}

.inner {
  grid-column: inner;
  position: relative;
  z-index: 1;
}

.cover-image {
  position: relative;
  box-shadow: 0px 0px 10px rgba(75, 75, 75, 0.45);
  max-width: 340px;
}

.content-left {
  text-align: center;
  margin-bottom: 70px;
}

.content-right {
  display: flex;
  justify-content: center;
  position: relative;
}

@keyframes expand1 {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(5%, 5%);
  }
}

@keyframes expand2 {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(10%, 10%);
  }
}

.image-stack {
  position: absolute;
  height: 100%;
  width: 100%;
  box-shadow: 0px 0px 10px rgba(75, 75, 75, 0.45);
  background: white;

  &:nth-of-type(1) {
    left: 0;
    top: 0;
    z-index: -1;
    animation: 0.5s ease-out 1s expand1;
  }

  &:nth-of-type(2) {
    left: 0;
    top: 0;
    z-index: -2;
    animation: 0.5s ease-out 1s expand2;
  }
}

.image-stack.image-stack--animated {
  &:nth-of-type(1) {
    animation: 0.5s ease-out 1s expand1;
    animation-fill-mode: forwards;
  }

  &:nth-of-type(2) {
    animation: 0.5s ease-out 1s expand2;
    animation-fill-mode: forwards;
  }
}

.logos {
  display: flex;
  align-items: center;
  margin-left: -8px;
  justify-content: center;
  flex-wrap: wrap;
}

:global(.resources-hero .logos img) {
  max-width: 80px;
  margin: 0 8px;
}

.title {
  line-height: 1;
  font-size: 40px;
  margin-bottom: 16px;
  word-break: break-word;
}

.description {
  font-size: 16px;
  margin-bottom: 34px;
}

.cta {
  margin-bottom: 45px;
}

.feature-logos-title {
  margin-bottom: 15px;
}

@include media-query(tablet) {
  .resources-hero {
    margin-bottom: 0;
    padding: 90px;
  }

  .background {
    transform: translate(50%, -50%) scale(1.2);
  }

  .inner {
    display: grid;
    grid-template-columns: [content-left] 1fr [content-right] minmax(auto, 45%);
    max-width: $container-max-width;
    grid-gap: 50px;
    margin: 0 auto;
    padding: 0;
    position: relative;
    z-index: 1;
  }

  .title {
    font-size: 60px;
    font-weight: 800;
  }

  .description {
    font-size: 26px;
    margin-bottom: 48px;
  }

  .content-left {
    text-align: left;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .cover-image {
    margin: auto;
  }

  .logos {
    justify-content: left;
  }
}
`